import { render, staticRenderFns } from "./PatientRadiology.vue?vue&type=template&id=173a3692&scoped=true"
import script from "./PatientRadiology.vue?vue&type=script&lang=js"
export * from "./PatientRadiology.vue?vue&type=script&lang=js"
import style0 from "./PatientRadiology.vue?vue&type=style&index=0&id=173a3692&prod&scoped=true&lang=css"
import style1 from "./PatientRadiology.vue?vue&type=style&index=1&id=173a3692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a3692",
  null
  
)

export default component.exports